// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__sIZEe","signatureButtonsRight":"ModalSign_signatureButtonsRight__2kiB9"};